import React, { Component } from "react";
import { Table, Tag, Space, Button, Tooltip, Dropdown, Menu, Pagination } from "antd";
import ProTable from "@ant-design/pro-table";
import { QuestionCircleOutlined, EllipsisOutlined } from "@ant-design/icons";

// import { EditableProTable, ProCard, ProFormField, ProFormRadio } from '@ant-design/pro-components';
// import type { ProColumns } from '@ant-design/pro-components';

const { Column, ColumnGroup } = Table;

class BlEditableProTable extends Component<any> {
  state = {
    result: [],
    pageSize: 10,
    editableKeys: ""
  };

  private renderMenuItem(list) {
    if (!list) return [];
    return (
      <Menu>
        {list?.map((v, index) => {
          return <Menu.Item key={index}>{v}</Menu.Item>;
        })}
      </Menu>
    );
  }

  renderColumnButtons() {
    let { columnButtons = [], columnButtonNum, columnButtonWidth = 120 } = this.props;
    let menuList = [];
    let preVarr = [];

    columnButtons?.map((v, index) => {
      if (index >= columnButtonNum) {
        menuList.push(<a> {v.btnName}</a>);
      } else {
        preVarr.push(<a> {v.btnName}</a>);
      }
    });

    let dropDownItem =
      columnButtonNum < columnButtons.length ? (
        <Dropdown overlay={this.renderMenuItem(menuList)}>
          <a onClick={(e) => e.preventDefault()}>
            <EllipsisOutlined />
          </a>
        </Dropdown>
      ) : (
        []
      );

    return preVarr.length > 0
      ? {
        title: "操作",
        key: "option",
        render: () => {
          return [...preVarr, dropDownItem];
        },
        width: columnButtonWidth,
        valueType: "option"
      }
      : [];
  }

  private renderHeaderTitle() {
    let { tableControlButtons } = this.props;

    return (
      tableControlButtons?.map((v, index) => {
        return (
          <Button type="primary" key={index} onClick={() => {
            this.props.getroot(function () {
              console.log(23234, this.state.di)
              this.setState({
                "di": true
              })
            });

          }}>
            {v.btnName}
          </Button>
        );
      }) || []
    );
  }

  private getRowSelection() {
    console.log("props:", this.props);
    let { chooseType } = this.props;
    if (chooseType === "none") return false;
    return {
      type: chooseType
    };
  }

  onChangePage = (page: number, pageSize: number) => {
    console.log("props:", this.props);
    let dataSourceId = this.props.dataSourceId;
    this.props.getroot(function () {
      this.dataSourceMap[dataSourceId].load({ "pageNum": page, "pageSize": pageSize });
    });
  };


  private getPagination() {
    let { isPage, pageSize } = this.props;
    return {
      show: isPage,
      pageSize: pageSize ? pageSize : 20,
      current: 1,
      total: this.props.tableData?.total ? this.props.tableData?.total : 20,
      onChange: (page: number, pageSize: number) => this.onChangePage(page, pageSize)
    };
  }


  render() {
    console.log(123321, this)
    return (
      <div>
        <ProTable
          rowKey="id"
          scroll={this.props.isScroll ? { y: 240 } : false}
          recordCreatorProps={{
            position: "bottom",
            record: () => ({ id: (Math.random() * 1000000).toFixed(0) }),
          }}
          columns={this.props.columns}
          request={async () => ({
            data: this.props.tableData?.result,
            total: 3,
            success: true,
          })}
          value={this.props.tableData?.result || []}
          // onChange={this.setDataSource}
        ></ProTable>
      </div>
    );
  }
}

export default BlEditableProTable;
